'use client';

import React, { createContext, useContext } from 'react';
// Keep long imports to avoid circular dependencies

export const DefaultsContext = /*#__PURE__*/createContext({});
export const DefaultsProvider = ({
  value,
  children
}) => {
  const currentDefaults = useContext(DefaultsContext);
  return /*#__PURE__*/React.createElement(DefaultsContext.Provider, {
    value: {
      ...currentDefaults,
      ...value
    }
  }, children);
};